import { CommonModule } from '@angular/common';
import { ApplicationRef, Component, Optional } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { SwUpdate } from '@angular/service-worker';
import { pageTransition, RouteService } from 'app';
import * as Credo from 'credo';
import { ToastContainerComponent, ToastService } from 'shared';

import {
  ButtonDirective,
  ModalModule,
  ToastBodyComponent,
  ToastCloseDirective,
  ToastComponent,
  ToasterComponent
} from '@coreui/angular-pro';

import { ScreenOrientation } from '@ionic-native/screen-orientation/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { MatomoTrackerService } from 'analytics';
import { AppInstanceService } from 'app';
import { AuthService } from 'auth';
import { TranslateService } from 'i18n';
import { Platform } from 'shared';

@Component({
  selector: 'app-root',
  template: `
      <div
        [style.opacity]="opacity"
        [@pageTransition]="animationState"
        (@pageTransition.start)="onPageAnimationStart($event)"
        (@pageTransition.done)="onPageAnimationDone($event)">
        <router-outlet #outlet="outlet"/>
      </div>
      <c-toaster placement="bottom-end" position="fixed">
        <c-toast *ngIf="displayUpdateToast()"
                #toast="cToast"
                [visible]="true"
                [autohide]="false"
                class="align-items-center
                text-white border-0"
                color="primary">
          <div class="d-flex">
            <c-toast-body>
              <span>A new version is available. Update now?</span>
              <div class="mt-2 pt-2 border-top">
                <button [cToastClose]="toast"
                        cButton
                        class="ms-1"
                        color="secondary"
                        size="sm"
                        (click)="displayUpdateToast.set(false)">
                  Close
                </button>
                <button cButton
                        color="primary"
                        size="sm"
                        (click)="onAppUpdate()">
                  Update
                </button>
              </div>
            </c-toast-body>
          </div>
        </c-toast>
        <toast-container></toast-container>
      </c-toaster>
      <c-modal *ngIf="displayInstanceModal()"
        #instanceModal
        id="verticallyCenteredModal"
        alignment="center"
        backdrop="static"
        [visible]="true"
        >
        <c-modal-header>
          <h5 cModalTitle>MNLO</h5>
        </c-modal-header>
        <c-modal-body>
          You are signed in with a different user account in another tab.
        </c-modal-body>
        <c-modal-footer>
          <button [cModalToggle]="instanceModal.id" cButton color="primary" (click)="onAppClose()" >
            Close this Tab
          </button>
        </c-modal-footer>
      </c-modal>
    `,
  styles: `
      :host {
        display: block;
        height: 100%;
      }
      div:first-child {
        position: relative;
        height: 100%;
      }
      c-toaster {
        bottom: 10px !important;
        right: 10px !important;
        width: auto;
      }
      c-toast { width: auto; }
      button { float: right; }
    `,
    imports: [CommonModule, RouterOutlet, ToastContainerComponent,
              ToasterComponent, ToastComponent, ToastBodyComponent, ToastCloseDirective,
              ButtonDirective, ModalModule],
    animations: [
      pageTransition
    ],
    standalone: true,
  })
  export class AppComponent extends Credo.AppComponent {

    constructor(router: Router,
                routeService: RouteService,
                @Optional()sw: SwUpdate,
                appInstanceService: AppInstanceService,
                authService: AuthService,
                screenOrientation: ScreenOrientation,
                statusBar: StatusBar,
                platform: Platform,
                applicationRef: ApplicationRef,
                @Optional() matomoTracker: MatomoTrackerService,
                toastService: ToastService,
                translateService: TranslateService) {
      super(router,
            routeService,
            sw,
            appInstanceService,
            authService,
            screenOrientation,
            statusBar,
            platform,
            applicationRef,
            matomoTracker,
            toastService,
            translateService
      );
    }
  }
